import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

import styles from './CompleteWithSubtasksModal.module.scss';

const CompleteWithSubtasksModal = ({
  openCount = 0,
  parentTitle = '',
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key !== 'Escape' || isSubmitting) return;
      onClose?.();
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isSubmitting, onClose]);

  const handleConfirm = async () => {
    const wasCompleted = (await onConfirm?.()) ?? false;
    if (!wasCompleted) return;
    onClose?.();
  };

  const modalContent = (
    <div className={styles.modalOverlay}>
      <button
        type="button"
        className={styles.modalBackdrop}
        aria-label="Close dialog"
        onClick={() => !isSubmitting && onClose?.()}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="complete-with-subtasks-title"
        className={styles.modalCard}
      >
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle} id="complete-with-subtasks-title">
            Complete with open sub-tasks?
          </div>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.modalCopy}>
            <span className={styles.modalCopyStrong}>{parentTitle}</span>
            {' has '}
            <span className={styles.modalCopyStrong}>
              {openCount} open sub-task{openCount === 1 ? '' : 's'}
            </span>
            .{' Completing this task will auto-close '}
            {openCount === 1 ? 'it' : 'them'}. Their assignees will be notified.
          </p>
        </div>

        <div className={styles.modalActions}>
          <button
            type="button"
            className={`${styles.modalActionButton} ${styles.modalSecondaryAction}`}
            onClick={() => onClose?.()}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`${styles.modalActionButton} ${styles.modalPrimaryAction}`}
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Completing...' : 'Complete all'}
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return modalContent;

  return createPortal(modalContent, document.body);
};

CompleteWithSubtasksModal.propTypes = {
  openCount: PropTypes.number,
  parentTitle: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

export default CompleteWithSubtasksModal;
